import { Navigate } from "react-router-dom";
import { isLogIn } from "./config/Apis";

export default function ProtectedRoute({ children }) {
  const { isToken } = isLogIn();

  if (!isToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
